module.exports = __webpack_public_path__ + "static/media/download_icon.8ef56f2f.svg";